// import { Box, Container, Typography, Skeleton } from "@mui/material";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import { useSitePolicy } from "../hooks/useSitePolicy";

// const PolicyLayout = ({ title, dataKey }) => {
//   const { data, loading } = useSitePolicy();

//   return (
//     <>
//       <Navbar />

//       <Box
//         sx={{
//           background: "#f4ece7",
//           minHeight: "100vh",
//           pt: 14,
//           pb: 10,
//         }}
//       >
//         {/* HEADER SECTION */}
//         <Container maxWidth="md">
//           <Box textAlign="center" mb={6}>
//             {/* MAIN TITLE */}
//             <Typography
//               variant="h3"
//               sx={{
//                 fontWeight: 600,
//                 fontFamily: "Playfair Display",
//               }}
//             >
//               {title.split(" ")[0]}{" "}
//               <Box component="span" sx={{ color: "#e65c2f" }}>
//                 {title.split(" ").slice(1).join(" ")}
//               </Box>
//             </Typography>

//             {/* Decorative Divider */}
//             <Box
//               sx={{
//                 width: 60,
//                 height: 2,
//                 background: "#e65c2f",
//                 mx: "auto",
//                 my: 2,
//               }}
//             />

//             {/* Subtitle */}
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 color: "#666",
//                 maxWidth: 600,
//                 mx: "auto",
//               }}
//             >
//               Welcome to IND Matrimony. By accessing or using our website,
//               mobile app, or services, you agree to the following {title}.
//             </Typography>

//             {/* Last Updated */}
//             <Typography
//               sx={{
//                 mt: 2,
//                 fontSize: "12px",
//                 textAlign: "right",
//                 color: "#999",
//               }}
//             >
//               Last Updated: 12 November 2025
//             </Typography>
//           </Box>
//         </Container>

//         {/* CONTENT SECTION */}
//         <Container maxWidth="md">
//           {loading ? (
//             <>
//               <Skeleton variant="text" width="60%" height={40} />
//               <Skeleton variant="rectangular" height={200} />
//             </>
//           ) : (
//             <Box
//               sx={{
//                 fontSize: "14px",
//                 lineHeight: 1.8,
//                 color: "#333",

//                 "& h1, & h2, & h3": {
//                   color: "rgba(230, 0, 0, 0.81)",
//                   fontWeight: 600,
//                   mt: 5,
//                   mb: 2,
//                 },

//                 "& p": {
//                   mb: 2,
//                 },

//                 "& ul": {
//                   pl: 3,
//                   mb: 2,
//                 },

//                 "& li": {
//                   mb: 1,
//                 },

//                 "& strong": {
//                   fontWeight: 600,
//                 },

//                 /* Section Divider Line */
//                 "& h2, & h3": {
//                   position: "relative",
//                 },

//                 "& h2::after, & h3::after": {
//                   content: '""',
//                   display: "block",
//                   width: "40px",
//                   height: "1px",
//                   background: "#e65c2f",
//                   marginTop: "8px",
//                 },
//               }}
//               dangerouslySetInnerHTML={{
//                 __html: data?.[dataKey] || "",
//               }}
//             />
//           )}
//         </Container>
//       </Box>

//       <Footer />
//     </>
//   );
// };

// export default PolicyLayout;

import { Box, Container, Typography, Skeleton } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useSitePolicy } from "../hooks/useSitePolicy";
import DecorativelineIcon from "../images/DecorativelineIcon.png";

const PolicyLayout = ({
  title,
  highlightText,
  subtitle,
  lastUpdated,
  dataKey,
  staticContent,
}) => {
  const { data, loading } = useSitePolicy();

  return (
    <>
      <Navbar />

      <Box
        sx={{
          background: "linear-gradient(180deg, #fff6f6, #fff)",
          minHeight: "100vh",
          pt: 14,
          pb: 10,
        }}
      >
        {/* HEADER SECTION */}
        <Container maxWidth="md">
          <Box textAlign="center" mb={4}>
            {/* TITLE */}
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                fontFamily: "Playfair Display",
              }}
            >
              {title}{" "}
              {highlightText && (
                <Box component="span" sx={{ color: "#e65c2f" }}>
                  {highlightText}
                </Box>
              )}
            </Typography>

            {/* Decorative Divider */}
            <Box
              component="img"
              src={DecorativelineIcon}
              alt="divider"
              sx={{
                display: "block",
                mx: "auto",
                my: 2,
                height: 12,
              }}
            />

            {/* Subtitle (comes from page) */}
            {subtitle && (
              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  maxWidth: 700,
                  mx: "auto",
                }}
              >
                {subtitle}
              </Typography>
            )}

            {/* {lastUpdated && (
              <Typography
                sx={{
                  mt: 2,
                  fontSize: "12px",
                  textAlign: "right",
                  color: "#242323",
                }}
              >
                Last Updated: {lastUpdated}
              </Typography>
            )} */}
          </Box>
        </Container>

        {/* CONTENT SECTION */}
       <Container maxWidth="md">
  {staticContent ? (
    <Box
      sx={{
        fontSize: "14px",
        lineHeight: 1.8,
        color: "#333",
        textAlign: "left",

        "& strong": {
          color: "rgba(230, 0, 0, 0.81)",
          fontWeight: 600,
        },

        "& h1, & h2, & h3": {
          color: "rgba(230, 0, 0, 0.81)",
          fontWeight: 600,
          mt: 5,
          mb: 2,
        },

        "& p": {
          mb: 2,
        },

        "& ul": {
          pl: 3,
          mb: 2,
        },

        "& li": {
          mb: 1,
        },

        "& h2::after, & h3::after": {
          content: '""',
          display: "block",
          width: "40px",
          height: "1px",
          background: "#e65c2f",
          marginTop: "8px",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: staticContent,
      }}
    />
  ) : loading ? (
    <>
      <Skeleton variant="text" width="60%" height={40} />
      <Skeleton variant="rectangular" height={200} />
    </>
  ) : (
    <Box
      sx={{
        fontSize: "14px",
        lineHeight: 1.8,
        color: "#333",
        textAlign: "left",

        "& strong": {
          color: "rgba(230, 0, 0, 0.81)",
          fontWeight: 600,
        },

        "& h1, & h2, & h3": {
          color: "rgba(230, 0, 0, 0.81)",
          fontWeight: 600,
          mt: 5,
          mb: 2,
        },

        "& p": {
          mb: 2,
        },

        "& ul": {
          pl: 3,
          mb: 2,
        },

        "& li": {
          mb: 1,
        },

        "& h2::after, & h3::after": {
          content: '""',
          display: "block",
          width: "40px",
          height: "1px",
          background: "#e65c2f",
          marginTop: "8px",
        },
      }}
      dangerouslySetInnerHTML={{
        __html:
          data?.[dataKey]
            ?.replace(/<p>.*Last Update\s*:[^<]*<\/p>/gi, "") || "",
      }}
    />
  )}
</Container>

      </Box>

      <Footer />
    </>
  );
};

export default PolicyLayout;
